import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
import ConfirmBtn from '../confirm-button';
export default class index extends Component {
    constructor(props) {
        super(props);
        this.state = { }
    }
    render() {
        return (
            <div className="pl-sm-5 pr-sm-5 ipad-box">
                <Row className="pr-3">
                    {this.props.devices.map((res, index) => (
                        <Col md={6} xs={6} key={index} className="pr-0">
                            <div className={res.isChecked ? "select-btn shake1" : this.props.loader ? "select-btn shake23" : 'select-btn'} onClick={() =>this.props.getDevice(res)}>
                                {res.isChecked && <img src={`${publicRuntimeConfig.staticFolder}/images/selected-mark.svg`} alt="selected-mark" className="support-select1" />}                                
                                <img src={`${publicRuntimeConfig.staticFolder}/images/` + res.image} alt="Apple Watch Repair Shop Near Me" className="devices-img" />
                                <span className="device-name">{res.name}</span>
                            </div>
                            {res.isChecked &&<div className="blur-box"><div className="blur-bg"></div></div>}
                        </Col>
                    ))}
                </Row>
                <div className={this.props.isChecked ? "mt-4 mobile-sticky-confirm-btn" : "mt-4 mobile-sticky-confirm-btn1"}>
                    <ConfirmBtn id="confirmSubmit" onClickEvent={this.props.setDeviceName} name="Confirm & Proceed" />
                </div>
            </div>
        )
    }
}
